/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ObjectMetadataResDto } from '../../models/object-metadata-res-dto';

export interface StorageControllerGetHeadObject$Params {
  key: string;
}

export function storageControllerGetHeadObject(
  http: HttpClient,
  rootUrl: string,
  params: StorageControllerGetHeadObject$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<ObjectMetadataResDto>> {
  const rb = new RequestBuilder(
    rootUrl,
    storageControllerGetHeadObject.PATH,
    'get',
  );
  if (params) {
    rb.query('key', params.key, {});
  }

  return http
    .request(
      rb.build({ responseType: 'json', accept: 'application/json', context }),
    )
    .pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ObjectMetadataResDto>;
      }),
    );
}

storageControllerGetHeadObject.PATH = '/storage/headObject';
